import { useEffect, useState } from "react";
import {
  EnumAlertDialogType,
  PopupInfoModel,
  ReportDetailModel,
  ReportModel,
  ShiftPlanModel,
} from "../Managers/dataStructures";
import { timeout } from "../Managers/wepApiManager";
import {
  ActivityIndicator,
  NegativeToast,
  PositiveToast,
} from "../Managers/utilityComponents";
import ReportDetail from "../Reports/ReportDetail";
import {
  processCSVReportForAdmin,
  processDownloadReport,
  processGetReportDetail,
} from "../Managers/processManager";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { dateToString } from "../Managers/utilityFunctions";
import { getLanguage } from "../Managers/dataProvider";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFReportDaily from "./PDFReportDaily";

interface ReportDetailProps {
  item: PopupInfoModel;
  closeDialog: () => void;
}

export default function AdminReportDetail(props: ReportDetailProps) {
  const isEnglish = getLanguage();
  //const [width, setWidth] = useState<number>(window.innerWidth);
  const [report, setReport] = useState<ReportModel>(props.item.props);
  const [array_reports, setArrayReports] = useState<ReportDetailModel[]>([]);
  const [comment, setComment] = useState<string>(
    report.shift_plan?.log !== undefined ? report.shift_plan?.log?.comments : ""
  );
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [activityIndicator, setActivityIndicator] = useState<boolean>(false);
  const [csvIndicator, setCSVIndicator] = useState<boolean>(false);
  const [isToastVisible, setIsToastVisible] = useState<EnumAlertDialogType>(
    EnumAlertDialogType.NEUTRAL
  );

  const dateString: string = dateToString(report.date as Date);
  const reportName: string =
    "Daily Report" +
    report.department +
    "-" +
    dateToString(report.date as Date) +
    ".pdf";
  useEffect(() => {
    //window.addEventListener("resize", handleWindowSizeChange);
    if (report.shift_plan === undefined) {
      return;
    }
    setIsRunning(true);

    processGetReportDetail(
      report.shift_plan,
      (
        shift_plan: ShiftPlanModel,
        array_reportDetail: ReportDetailModel[],
        total_elasped_time: string
      ) => {
        setIsRunning(false);
        let temp_report = report;
        temp_report.date = temp_report.shift_plan?.date as Date;
        temp_report.total_hours = total_elasped_time;
        temp_report.shift_plan = shift_plan;
        setReport(temp_report);
        setArrayReports(array_reportDetail);
      }
    );
    // return () => {
    //   window.removeEventListener("resize", handleWindowSizeChange);
    // };
  }, []);

  // function handleWindowSizeChange() {
  //   setWidth(window.innerWidth);
  //   console.log("width=" + window.innerWidth);
  // }

  async function onDownload() {
    if (isRunning === true) {
      return;
    }
    setActivityIndicator(true);
    onCreatePDF();
    await processDownloadReport();
    showAlert(true);
    setActivityIndicator(false);
  }

  async function onDownloadCSV() {
    if (isRunning === true) {
      return;
    }
    setCSVIndicator(true);
    downloadCSV();
    await processDownloadReport();
    showAlert(true);
    setCSVIndicator(false);
  }

  function downloadCSV() {
    const reportDate = dateToString(report.shift_plan?.date as Date);
    const reportName: string =
      "Daily Report-" +
      report.department +
      "-" +
      dateToString(report.shift_plan?.date as Date) +
      ".csv";
    const element = document.createElement("a");
    const csv_text: string = processCSVReportForAdmin(
      array_reports,
      reportDate,
      report.department,
      report.total_hours as string,
      report.shift_plan?.log !== undefined
        ? report.shift_plan?.log?.comments
        : ""
    );

    const file = new Blob([csv_text], {
      type: "text/plain; charset:UTF-8",
    });

    element.href = URL.createObjectURL(file);
    element.download = reportName;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  /*
  function printDocument() {
    const reportName: string =
      report.department + "-" + report.shift_plan?.log?.end_at + ".pdf";
    const input = document.getElementById("divToPrint");
    if (input !== null) {
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "in",
          format: [2, 3],
        });
        //pdf.addImage(imgData, "JPEG", 0, 0, 200, 100);
        pdf.addImage(imgData, "JPEG", 0, 0, 2, 1, reportName, "SLOW");
        // pdf.output('dataurlnewwindow');
        pdf.save(reportName);
      });
    }
  }
  */

  function onCreatePDF() {
    const reportName: string =
      "Daily Report" +
      report.department +
      "-" +
      dateToString(report.date as Date) +
      ".pdf";
    const input = document.getElementById("divToPrint");
    let formatHeight: number = 4;
    formatHeight = array_reports.length * 100;
    //let isLandscape: boolean = false;
    //isLandscape = formatHeight < 400;
    //const reducer: number = 0.5;
    //console.log("reducer=" + reducer);
    //formatHeight = formatHeight / reducer;
    //let formatWidth: number = 500;
    if (input !== null) {
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: formatHeight < 500 ? "landscape" : "portrait",
          unit: "px",
          format: "a4",
        });
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(reportName);
        // const pdf = new jsPDF({
        //   orientation: isLandscape ? "landscape" : "portrait",
        //   unit: "px",
        //   format: [formatWidth, formatHeight],
        // });
        // pdf.addImage(
        //   imgData,
        //   "PNG",
        //   0,
        //   0,
        //   500,
        //   formatHeight / 2,
        //   reportName,
        //   "SLOW"
        // );
        // pdf.save(reportName);
      });
    }
  }

  function onComment(value: string) {
    setComment(value);
  }

  function onCancel() {
    props.closeDialog();
  }

  async function showAlert(isPositive: boolean) {
    if (isPositive) {
      setIsToastVisible(EnumAlertDialogType.POSITIVE);
    } else {
      setIsToastVisible(EnumAlertDialogType.NEGATIVE);
    }
    await timeout(3000);
    setIsToastVisible(EnumAlertDialogType.NEUTRAL);
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish
              ? "Report : Daily Branch"
              : "Bericht: Filialtagesbericht"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isEnglish
              ? "Admin can see all approved reports of all branches and shifts from selected day."
              : "Der Administrator kann alle genehmigten Berichte aller Filialen und Schichten des ausgewählten Tages einsehen."}
          </p>
        </div>
        <button
          onClick={onCancel}
          type="button"
          className="block rounded-md mt-5  px-3 py-2 text-center text-sm font-semibold text-white shadow-sm bg-red-600 hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          //className="text-sm mt-5 font-semibold leading-6 text-white block rounded-md shadow-sm bg-red-600 hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
        >
          {isEnglish ? "Back" : "Zurück"}
        </button>
      </div>
      <div className="mt-4 sm:mt-0 sm:flex-none flex items-center gap-x-6">
        <PDFDownloadLink
          document={
            <PDFReportDaily
              dateString={dateString}
              department={report.department}
              signatory={report.signatory}
              total_hours={report.total_hours}
              comment={comment}
              array_reports={array_reports}
            />
          }
          fileName={reportName}
        >
          <button
            type="button"
            //onClick={onDownload}
            className="block rounded-md mt-5 bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {activityIndicator === true ? ActivityIndicator(0) : null}
            Download PDF
          </button>
        </PDFDownloadLink>
        <button
          type="button"
          onClick={onDownloadCSV}
          className="block rounded-md mt-5 bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          {csvIndicator === true ? ActivityIndicator(0) : null}
          Download CSV
        </button>
      </div>
      <div id="divToPrint">
        <div className="mt-5 px-2">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {isEnglish ? "Report: Daily Branch" : "Bericht: Filialtagesbericht"}
          </label>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {/* {"Date: " + dateToString(report.date as Date)} */}
            {(isEnglish ? "Date: " : "Datum: ") + dateString}
          </label>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {(isEnglish ? "Branch: " : "Filiale: ") + report.department}
          </label>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {(isEnglish ? "Branch manager: " : "Filial-/Schichtleiter: ") +
              report.signatory}
          </label>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {(isEnglish ? "Total hours: " : "Gesamtarbeitsstunden: ") +
              report.total_hours}
          </label>
        </div>
        <div className="col-span-full mt-2 px-2">
          <label
            htmlFor="about"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            {isEnglish
              ? "Branch Manager's comments"
              : "Anmerkungen des Filial-/Schichtleiters"}
          </label>
          <div className="mt-2">
            <textarea
              id="comment"
              name="comment"
              disabled={true}
              rows={3}
              onChange={(x) => onComment(x.currentTarget.value)}
              defaultValue={comment}
              className="block w-full rounded-md border-0 py-1.5 pl-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            ></textarea>
          </div>

          {isToastVisible === EnumAlertDialogType.NEUTRAL
            ? null
            : isToastVisible === EnumAlertDialogType.POSITIVE
            ? PositiveToast(
                isEnglish ? "Report Downloaded" : "Bericht heruntergeladen"
              )
            : NegativeToast(
                isEnglish
                  ? "Error: Unable to process request."
                  : "Fehler: Anforderung konnte nicht verarbeitet werden."
              )}
        </div>
        {isRunning ? (
          <div className="mt-5 flex items-center justify-center">
            {ActivityIndicator(1)}
          </div>
        ) : null}
        <div>
          <ReportDetail
            array_reportDetail={array_reports}
            title={report.title}
            date={report.shift_plan?.log?.end_at}
          />
        </div>
      </div>
    </div>
  );
}
